import toast from '@/plugins/toast/toast'
import vue from 'vue'

const showPosition = (callback, position) => {
  return callback(position.coords.latitude, position.coords.longitude)
}

const showError = (callback, error) => {
  if (typeof callback === 'function') {
    return callback(error)
  }

  switch (error.code) {
    case error.PERMISSION_DENIED:
      return toast(vue, {}).warning('Você negou o acesso a GeoLocalização.')
    case error.POSITION_UNAVAILABLE:
      return toast(vue, {}).warning('Informação de GeoLocalização não disponível.')
    case error.TIMEOUT:
      return toast(vue, {}).warning('A solicitação para obter a localização do usuário excedeu o tempo limite.')
    case error.UNKNOWN_ERROR:
      return toast(vue, {}).warning('Ocorreu um erro desconhecido.')
  }
}

export default (callback, callbackError = null) => {
  if (typeof callback !== 'function') {
    return toast(vue, {}).error('Error interno!')
  }

  if (!navigator.geolocation) {
    return toast(vue, {}).warning('Seu navegador não suporta GeoLocalização')
  }

  navigator.geolocation.getCurrentPosition(
    position => showPosition(callback, position),
    error => showError(callbackError, error)
  )
}



// WEBPACK FOOTER //
// ./src/helpers/geolocation.js